<template>
  <div>
    <div class="profile-management__header">
      <h2 class="profile-management__header__h2">
        Contatos
      </h2>
      <button
        id="save-contacts"
        class="btn btn-primary btn-new"
        @click="updateContacts"
      >
        <img src="/static/images/icon-check-thin.svg">
        Salvar
      </button>
    </div>
    <loading v-if="loadingStatus" />
    <div v-else>
      <template v-for="section in sections">
        <div
          v-if="
            section.type !== 'ASSESSORIA_CIENTIFICA' && section.type !== 'EXECUTIVO_VENDAS'
          "
          :key="section.label"
          :data-section-type="section.type"
          class="contact-section"
        >
          <h3>{{ section.label }}</h3>
          <div v-if="section.type === 'NOVA_AMOSTRA'">
            <p>
              E-mail utilizado para informar o cliente sobre a necessidade de recoletas,
              remarcações e amostras não recebidas
            </p>
          </div>
          <div v-if="section.type === 'LAB'">
            <p>
              E-mail utilizado para comunicar o cliente sobre resultados de pânico,
              discussões sobre laudos e dúvidas técnicas
            </p>
          </div>
          <div
            v-for="(contact, index) in section.contacts"
            :key="index"
          >
            <div class="general-data__box-wrapper">
              <div class="general-data__content-wrapper">
                <div
                  v-if="section.type !== 'NOVA_AMOSTRA' && section.type !== 'LAB'"
                  class="contact-section__box-inputs"
                >
                  <input
                    v-model="contact.name"
                    type="text"
                    placeholder="Nome"
                    :disabled="!toggle.generalData"
                    :class="{ 'input-error': contact.error && contact.error.includes('Nome') }"
                    @input="validateContact(contact, section.type)"
                  >
                </div>
                <div class="contact-section__box-inputs">
                  <input
                    v-model="contact.email"
                    type="email"
                    placeholder="E-mail"
                    :disabled="!toggle.generalData"
                    :class="{ 'input-error': contact.error && contact.error.includes('E-mail') }"
                    @input="validateContact(contact, section.type)"
                  >
                  <input
                    v-if="section.type !== 'NOVA_AMOSTRA' && section.type !== 'LAB'"
                    v-model="contact.phone"
                    v-mask="'(##) #####-####'"
                    type="tel"
                    placeholder="Telefone"
                    :disabled="!toggle.generalData"
                    :class="{ 'input-error': contact.error && contact.error.includes('Telefone') }"
                    @input="validateContact(contact, section.type)"
                  >
                </div>
              </div>

              <button
                v-if="toggle.generalData"
                class="add-button delete-button"
                @click="removeContact(section.label, index)"
              >
                <svg-loader
                  class="delete"
                  src="/static/images/icon-trash.svg"
                />
              </button>
            </div>
            <span
              v-if="contact.error"
              class="error"
            >{{ contact.error }}</span>
          </div>
          <button
            v-if="section.contacts.length < 5 && toggle.generalData"
            class="not-gap add-button"
            @click="addContact(section.label)"
          >
            + adicionar novo
            {{
              section.type === "NOVA_AMOSTRA" || section.type === "LAB"
                ? "e-mail"
                : "e-mail e telefone"
            }}
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import generalDataService from "@/api/generalData";
import notify from "@/api/notification";
import { validateEmail, validateBothPhoneNumbers } from "@/utils/validations";

export default {
  data() {
    return {
      loadingStatus: false,
      sections: [
        { label: "Nova Amostra", contacts: [], type: "NOVA_AMOSTRA" },
        { label: "Laboratório", contacts: [], type: "LAB" },
        { label: "Comercial", contacts: [], type: "COMERCIAL" },
        { label: "Técnico", contacts: [], type: "TECNICO" },
        { label: "Financeiro", contacts: [], type: "FINANCEIRO" },
        { label: "Gestor", contacts: [], type: "GESTOR" },
        { label: "Nps", contacts: [], type: "NPS" },
        { label: "Assessoria Científica", contacts: [], type: "ASSESSORIA_CIENTIFICA" },
        { label: "Executivo de Vendas", contacts: [], type: "EXECUTIVO_VENDAS" },
      ],
      contactTypes: {
        1: "COMERCIAL",
        2: "TECNICO",
        3: "FINANCEIRO",
        4: "GESTOR",
        5: "NOVA_AMOSTRA",
        6: "LAB",
        8: "NPS",
        9: "ASSESSORIA_CIENTIFICA",
        10: "EXECUTIVO_VENDAS",
      },
      errorMessages: {
        name: 'Nome é obrigatório',
        email: 'E-mail inválido',
        phone: 'Telefone inválido'
      }
    };
  },
  computed: {
    ...mapGetters(["profile", "toggle"]),
  },
  mounted() {
    this.getContacts();
  },
  methods: {
    validateContact(contact, type) {
      contact.error = '';

      if (type === 'ASSESSORIA_CIENTIFICA' || type === 'EXECUTIVO_VENDAS') {
        return true;
      }

      if (type !== 'NOVA_AMOSTRA' && type !== 'LAB') {
        if (!contact.name || contact.name.trim() === '') {
          contact.error = this.errorMessages.name;
          return false;
        } 

        if (!contact.email || !validateEmail(contact.email)) {
          contact.error = this.errorMessages.email;
          return false;
        }

        if (!contact.phone || !validateBothPhoneNumbers(contact.phone)) {
          contact.error = this.errorMessages.phone;
          return false;
        }
      }

      if (!contact.email || !validateEmail(contact.email)) {
        contact.error = this.errorMessages.email;
        return false;
      }

      return true;
    },

    addContact(sectionLabel) {
      const section = this.sections.find((sec) => sec.label === sectionLabel);
      if (section) {
        const newContact = section.type === "NOVA_AMOSTRA" || section.type === "LAB"
          ? {
            email: "",
            contactType: section.type,
            error: ""
          }
          : {
            name: "",
            email: "",
            phone: "",
            contactType: section.type,
            error: ""
          };
        section.contacts.push(newContact);
      }
    },
    processContacts(contacts) {
      this.sections.forEach((section) => {
        section.contacts = [];
      });
      contacts.forEach((contact) => {
        const contactTypeId = contact.contactType.id;
        const contactTypeLabel = this.contactTypes[contactTypeId];
        const section = this.sections.find((sec) => sec.type === contactTypeLabel);
        if (section) {
          section.contacts.push({
            id: contact.id,
            name: contact.name,
            email: contact.email,
            phone: contact.phone,
            contactType: contactTypeLabel,
            laborId: contact.laborId ? contact.laborId : this.profile.id_laboratory,
          });
        }
      });
    },
    validateAllContacts() {
      let isValid = true;
      let firstErrorInput = null;

      this.sections.forEach((section) => {
        section.contacts.forEach((contact) => {
          if (!this.validateContact(contact, section.type)) {
            isValid = false;
            if (!firstErrorInput) {
              // Encontra o primeiro input com erro
              const sectionEl = document.querySelector(`[data-section-type="${section.type}"]`);
              if (sectionEl) {
                const errorInput = sectionEl.querySelector('.input-error');
                if (errorInput) {
                  firstErrorInput = errorInput;
                }
              }
            }
          }
        });
      });

      if (firstErrorInput) {
        firstErrorInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return isValid;
    },
    updateContacts() {
      const isValid = this.validateAllContacts();

      if (!isValid) {
        notify({
          title: "AVISO:",
          message: "Por favor, corrija os campos com erro antes de salvar.",
        });
        return;
      }

      this.loadingStatus = true;

      const contactsPayload = [];
      this.sections.forEach((section) => {
        section.contacts.forEach((contact) => {
          const contactData = { ...contact };
          delete contactData.error;
          contactsPayload.push(contactData);
        });
      });

      generalDataService
        .updateContacts(contactsPayload)
        .then(() => {
          this.loadingStatus = false;
          notify({
            title: "AVISO:",
            message: "Contatos atualizados com sucesso."
          });
        })
        .catch((err) => {
          this.loadingStatus = false;
          notify({
            title: "AVISO:",
            message: "Erro ao atualizar contatos!"
          });
          console.error("Erro ao buscar contatos:", err);
        });
    },
    removeContact(sectionLabel, index) {
      const section = this.sections.find((sec) => sec.label === sectionLabel);
      if (!section) return;
      section.contacts.splice(index, 1);
    },
    getContacts() {
      this.loadingStatus = true;
      generalDataService
        .getContacts()
        .then((res) => {
          this.processContacts(res.data);
          this.loadingStatus = false;
        })
        .catch((err) => {
          this.loadingStatus = false;
          console.error("Erro ao buscar contatos:", err);
        });
    },
  },
};
</script>

<style lang="scss">
.profile-management__header {
  margin-bottom: 24px;

  .contact-section__box-inputs input {
    transition: all 0.3s ease;
  }
}

.contact-section {
  span.error {
    display: block;
    color: red;
    font-weight: 600;
    margin-top: -14px;
    font-size: 12px;
    padding-left: 8px;
  }

  .input-error {
    border: 1px solid red !important;
    background-color: rgba(255, 0, 0, 0.05);
  }
}
</style>
